export default __webpack_public_path__ + "static/media/facebook-filled-blue.068a3430.svg";